export default __webpack_public_path__ + "images/progressLogo.v-eba6182323c0286df13f9b73971da086.png";